import ArrowLeftRightIconDownIcon from "@/components/icons/ArrowLeftRightIcon"
import FightDownIcon from "@/components/icons/FightDownIcon"
import FightUpIcon from "@/components/icons/FightUpIcon"
import { CalendarOutlined } from "@ant-design/icons"
import { faCouch, faSearch, faUsers } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Card, Checkbox, Col, ConfigProvider, DatePicker, Divider, Form, Input, Row, Select, theme } from "antd"
import { useTransition } from "react"
import FormItem from "antd/es/form/FormItem"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import dayjs from "dayjs"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { cabinClasses } from "@/constants/flight/cabinClass"
import { DatePickerProps } from "antd/lib"

import Text from "@/components/common/Typography/Text"
import { searchFlightDrawers } from "./DrawerFormSearchFlightWrapper"
import { getQueryStringSearchFlight } from "@/utils/string/getQueryStringSearchFlight"
import { useTERouter } from "@/hooks/app/useTERouter"
import { useTETranslation } from "@/hooks/app/useTETranslation"
import { useTranslation } from "react-i18next"
import { toast } from "react-toastify"
import { getFlightsAllAirlines } from "@/utils/flight/getFlightsAllAirlines"

const FormSearchFlightMobile = ({
  onlyContent,
  fetchData,
  onAfterSearch,
}: {
  onlyContent?: boolean
  fetchData?: boolean
  onAfterSearch?: () => void
}) => {
  const { getAirportCityName, getValidDayjs } = useTETranslation()
  const token = theme.useToken().token
  const selectedInputFlightIndex = useAppSelector(state => state.flight.selectedFligthInputIndex)
  const selectedInputFlight = useAppSelector(state => state.flight.inputFlights[selectedInputFlightIndex])
  const inputPassenger = useAppSelector(state => state.flight.inputAdult + state.flight.inputChildren + state.flight.inputInfant)
  const cabinClass = useAppSelector(state => state.flight.cabinClass)
  const checkedItinerary = useAppSelector(state => !!state.flight.checkedItinerary)
  const dispatch = useAppDispatch()
  const router = useTERouter()
  const [isSearching, startSearchTransition] = useTransition()
  const dateForm = getValidDayjs(selectedInputFlight?.dateFrom)
  const dateTo = getValidDayjs(selectedInputFlight?.dateTo)
  const { t } = useTranslation()

  const disabledDate: DatePickerProps['disabledDate'] = (current) => {
    return current && current <= dayjs().add(-1, 'days').endOf('day');
  };

  const disabledDateTo: DatePickerProps['disabledDate'] = (current) => {
    return current && current < dayjs().endOf('day') || current < dateForm.endOf('day');
  };

  let content = (
    <Form
      layout='vertical'
      className="flights__formsearch-mobile"
      style={{ width: '100%' }}
    >
      <Row style={{ marginBottom: '1rem' }} justify='center' gutter={10}>
        <Col>
          <Button
            onClick={() => {
              dispatch(flightActions.changeCheckedItinerary(false))
            }}
            size='large'
            ghost={checkedItinerary}
            shape='round'
            type='primary'
            style={{ width: '11rem' }}
          >
            {t("flight.one_way")}
          </Button>
        </Col>
        <Col>
          <Button
            size='large'
            ghost={!checkedItinerary}
            shape='round'
            type='primary'
            onClick={() => {
              dispatch(flightActions.changeCheckedItinerary(true))
              dispatch(flightActions.changeDateTo({ indexInputFlight: selectedInputFlightIndex, dateTo: dateForm }))
            }}
            style={{ width: '11rem' }}
          >
            {t("flight.round_trip")}
          </Button>
        </Col>
      </Row>
      <Row wrap={false}>
        <Col flex={1}>
          <FormItem
            label={t("flight.from")}
          >
            <Row wrap={false}>
              <Col>
                <Row align='middle' style={{ height: '100%' }}>
                  <FightUpIcon />
                </Row>
              </Col>
              <Col flex={1}>
                <Input
                  value={selectedInputFlight?.fromAirport
                    ? `${getAirportCityName(selectedInputFlight?.fromAirport) || selectedInputFlight?.fromAirport?.country} (${selectedInputFlight?.fromAirport?.code})`
                    : ''}
                  variant='borderless'
                  size='large'
                  placeholder={t("flight.from_placeholder")}
                  readOnly
                  onClick={() => searchFlightDrawers.selectPlacementFrom?.open()}
                />
              </Col>
            </Row>

            <Divider style={{ marginTop: '1rem', marginBottom: 0 }} />
          </FormItem>
          <FormItem
            label={t("flight.to")}
          >
            <Row wrap={false} align='middle'>
              <Col>
                <Row align='middle' style={{ height: '100%' }}>
                  <FightDownIcon />
                </Row>
              </Col>
              <Col flex={1}>
                <Input
                  value={selectedInputFlight?.toAirport
                    ? `${getAirportCityName(selectedInputFlight?.toAirport) || selectedInputFlight?.toAirport?.country} (${selectedInputFlight?.toAirport?.code})`
                    : ''}
                  variant='borderless'
                  size='large'
                  placeholder={t("flight.to_placeholder")}
                  readOnly
                  onClick={() => searchFlightDrawers.selectPlacementTo?.open()}
                />
              </Col>
            </Row>

            <Divider style={{ marginTop: '1rem', marginBottom: 0 }} />
          </FormItem>
        </Col>
        <Col>
          <Row align='middle' style={{ height: '100%' }}>
            <Button
              type='primary'
              ghost
              size='large'
              shape='circle'
              style={{ marginLeft: 5, marginRight: '2rem' }}
              icon={<ArrowLeftRightIconDownIcon />}
              onClick={() => dispatch(flightActions.swicthBtwAirports({ flightInputIndex: 0 }))}
            />
          </Row>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <FormItem
            label={t("flight.departure_date")}
          >
            <Row
              style={{
                position: 'relative'
              }}
            >
              <button
                type='button'
                style={{
                  padding: 0,
                  margin: 0,
                  outline: 'none',
                  border: 'none',
                  background: 'none',
                  height: "100%",
                  width: "100%",
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: 10
                }}
                onClick={() => searchFlightDrawers.selectDate?.open('from')}
              />
              <Col>
                <Row align='middle' style={{ height: '100%' }}>
                  <CalendarOutlined />
                </Row>
              </Col>
              <Col flex={1}>
                <DatePicker
                  open={false}
                  disabledDate={disabledDate}
                  value={dateForm}
                  // onChange={(value, valueStr) => {
                  //   if (value.valueOf() > dateTo.valueOf()) {
                  //     const _dateTo = value.add(1, 'days')
                  //     dispatch(flightActions.changeDateTo({ indexInputFlight: selectedInputFlightIndex, dateTo: _dateTo }))
                  //   }
                  //   dispatch(flightActions.changeDateFrom({ indexInputFlight: selectedInputFlightIndex, dateFrom: value }))
                  // }}
                  readOnly
                  className={`home__searching-mobile--form-date${dateForm ? ' home__searching-mobile--date-selected' : ''}`}
                  style={{ width: '100%' }}
                  variant='borderless'
                  format="DD MMMM, YYYY"
                  inputReadOnly
                />
              </Col>
            </Row>
            <Divider style={{ marginTop: '1rem', marginBottom: 0 }} />
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem
            className="flights__formsearch--input-mobile"
            label={(
              <Row wrap={false} justify='space-between' align={'middle'}>
                <Col>
                  {t("flight.return_date")}
                </Col>
                <Col>
                  <Checkbox
                    onClick={() => {
                      dispatch(flightActions.changeCheckedItinerary(!checkedItinerary))
                      dispatch(flightActions.changeDateTo({ indexInputFlight: selectedInputFlightIndex, dateTo: dateForm }))
                      if (!checkedItinerary) {
                        searchFlightDrawers.selectDate?.open('to')
                      }
                    }}
                    classNames={{
                      root: "home__searching--checkbox"
                    }}
                    checked={!!checkedItinerary}
                  >
                    {t("flight.round_trip")}
                  </Checkbox>
                </Col>
              </Row>
            )}
          >
            <Row
              style={{
                position: 'relative'
              }}
            >
              <button
                type='button'
                style={{
                  padding: 0,
                  margin: 0,
                  outline: 'none',
                  border: 'none',
                  background: 'none',
                  height: "100%",
                  width: "100%",
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  zIndex: 10
                }}
                onClick={() => {
                  if (!checkedItinerary) {
                    dispatch(flightActions.changeCheckedItinerary(true))
                    dispatch(flightActions.changeDateTo({
                      indexInputFlight: selectedInputFlightIndex,
                      dateTo: dateForm,
                    }))
                  }
                  searchFlightDrawers.selectDate?.open('to')
                }}
              />
              <Col>
                <Row align='middle' style={{ height: '100%' }}>
                  <CalendarOutlined />
                </Row>
              </Col>
              <Col flex={1}>
                <DatePicker
                  open={false}
                  placeholder={t("flight.return_date_placeholder")}
                  // disabled={!checkedItinerary}
                  disabledDate={disabledDateTo}
                  value={checkedItinerary ? dateTo : null}
                  style={{ width: '100%', ...(checkedItinerary ? {} : { color: token.colorTextDisabled }) }}
                  variant='borderless'
                  format="DD MMMM, YYYY"
                  className={`home__searching-mobile--form-date${checkedItinerary && dateTo ? ' home__searching-mobile--date-selected' : ''}`}
                />
              </Col>
              {/* <Col>
                    <Row align='middle' style={{ height: '100%' }}>
                      <Switch
                        onChange={(e) => {
                          dispatch(flightActions.changeCheckedItinerary(e))
                          if (!!e) {
                            dispatch(flightActions.changeDateTo({ indexInputFlight: selectedInputFlightIndex, dateTo: dateForm }))
                          }
                        }}
                        value={checkedItinerary}
                        size='small'
                      />
                    </Row>
                  </Col> */}
            </Row>
            <Divider style={{ marginTop: '1rem', marginBottom: 0 }} />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem
            label={t("booking.passenger")}
          >
            <Row align='middle'>
              <Select
                prefix={<Text type='secondary'><FontAwesomeIcon icon={faUsers} /></Text>}
                variant='borderless'
                size='large'
                placeholder={t("booking.passenger_placeholder")}
                open={false}
                value={`${inputPassenger > 9 ? '' : '0'}${inputPassenger}`}
                onClick={() => searchFlightDrawers.selectPassenger?.open()}
              />
            </Row>
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            label={t("flight.class")}
          >
            <Row align='middle'>
              <Select
                prefix={<Text type='secondary'><FontAwesomeIcon icon={faCouch} /></Text>}
                value={(cabinClasses as any)[cabinClass]?.name ? t((cabinClasses as any)[cabinClass].name) : t("common.all")}
                variant='borderless'
                size='large'
                open={false}
                placeholder={t("flight.class_placeholder")}
                onClick={() => searchFlightDrawers.selectClass?.open()}
              />
            </Row>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Button
            onClick={() => {
              if (!selectedInputFlight?.toAirport) {
                toast.error(t("flight.airport_to_required"))
                return;
              }
              if (!selectedInputFlight?.fromAirport) {
                toast.error(t("flight.airport_from_required"))
                return;
              }

              if (fetchData) {
                startSearchTransition(() => getFlightsAllAirlines({
                  onStart({ newSearchString }) {
                    router.push(`/flights/result${newSearchString}`)
                    onAfterSearch?.()
                  },
                }))
              } else {
                startSearchTransition(() => {
                  searchFlightDrawers.flights?.open()
                  router.push(`/flights/result?${getQueryStringSearchFlight()}`)
                })
              }
            }}
            loading={isSearching}
            disabled={isSearching}
            icon={<FontAwesomeIcon icon={faSearch} />}
            size='large'
            type='primary'
            block
          >
            {t("flight.search_flight")}
          </Button>
        </Col>
      </Row>
    </Form>
  )

  if (!onlyContent) {
    content = (
      <Card>
        {content}
      </Card>
    )
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Form: {
            verticalLabelPadding: 0,
          }
        }
      }}
    >
      {content}
    </ConfigProvider>
  )
}

export default FormSearchFlightMobile